export * from './skeleton';

export * as skeletonStyleConfigs from './style-configs';
